import styled from 'styled-components';
import COLORS from '../../utils/Colors';
import { Link } from "react-router-dom";

export const Container = styled(Link)`
    background-color: ${COLORS.freshaWhite};
    border-radius: 8px;
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 16px;
    border: 1px solid ${COLORS.freshaGray100};
    box-shadow: none;

    &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    & {
        color: ${COLORS.freshaBlack};
    }
`;

export const BusinessSection = styled.div`
    margin-bottom: 12px;
    display: flex;
    gap: 12px;
`;

export const ImageContainer = styled.div`
    
`;

export const CardImage = styled.img`
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 6px;
    flex-shrink: 0;
`;

export const InfoContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: flex-start;
`;

export const Review = styled.div`
    display: flex;
    gap: 0.25rem;
    align-items: center;
    margin-top: 4px;
    margin-bottom: 4px;
`;

export const LocationInfo = styled.p`
    font-size: 0.875rem;
    color: ${COLORS.freshaGray500};
    margin: 0;
`;

export const Title = styled.p`
    font-size: 1.125rem;
    font-weight: 600;
    color: ${COLORS.freshaBlack};
    margin: 0 0 4px 0;
    text-align: initial;
`;

export const LocationContainer = styled.div`
    margin-top: 0;
`;

export const AmountCommentsContainer = styled.div`

`;

export const ReviewContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
`;

export const ScoreText = styled.p`
    font-size: 0.875rem;
    font-weight: 600;
    color: ${COLORS.freshaBlack};
    margin: 0;
`;

export const ReviewCount = styled.span`
    font-size: 0.875rem;
    color: ${COLORS.freshaGray500};
    margin-left: 2px;
`;

export const CommentsText = styled.p`
    font-size: 0.8em;
    color: ${COLORS.black};
    margin: 0;
`;

export const LeftSideData = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0;
`;

export const SeparatorLine = styled.div`
    height: 5px;
    border-bottom: 1px solid ${COLORS.freshaGray100};
`;

export const ServicesSection = styled.div`
`;

export const ServicesContainer = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    margin: 0;
`;

export const ServiceItemDescription = styled.div`

`;

export const ServiceItemDescriptionText = styled.p`
    font-size: 0.875rem;
    color: ${COLORS.freshaGray700};
    margin: 0;

    & span {
        color: ${COLORS.freshaGray500};
        font-size: 0.8125rem;
        font-weight: 400;
    }
`;

export const SeeAllServices = styled.div`
    font-size: 0.875rem;
    color: ${COLORS.freshaBlack};
    font-weight: 500;
    margin-top: 8px;
    padding: 6px 0;
`;

export const MainTitleContainer = styled.div`
    margin: 0;
`;


